export default "__VITE_ASSET__CnooPE0X__"